// src/hooks/useDesignations.js
import { useEffect, useState } from "react";
import axios from "../axiosInstance";

const toUI = (r) => ({
    id: r.id,
    label: r.label ?? r.titre ?? "",
    prixUnitaire: Number(r.prixUnitaire ?? r.prix ?? 0),
    tva: r.tva !== undefined ? Number(r.tva) : 20,
    type: r.type ?? "materiaux",
});

export function useDesignations() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const refetch = async () => {
        setLoading(true);
        try {
            // IMPORTANT: si axiosInstance a baseURL '/api', ne pas re-préfixer '/api' ici
            const { data } = await axios.get("/designations");
            setItems(Array.isArray(data) ? data.map(toUI) : []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { refetch(); }, []);
    return { items, loading, refetch };
}
